export const getUnmaskedValue = (value: string) =>
  String(value).replace(/\D/g, '');
